import './HeaderTitleConfig';
import { useTheme } from '@mui/material';
import { FC, ReactNode } from 'react';
import { Trans } from 'react-i18next';

import AtomFlex from '../../../../../../atoms/AtomFlex';
import AtomGrid from '../../../../../../atoms/AtomGrid';
import AtomTypography from '../../../../../../atoms/AtomTypography/AtomTypography';
import { styleConfigs } from '../../../../../../resources/styleConfigs';
import SkillTrackerStatusSpan from '../../../../../SkillTrackerStatusSpan/SkillTrackerStatusSpan';
import { skillStatusType, modalHeaderTitleType } from '../../../../NewModalLayoutComponent';

interface IHeaderTitleProps {
  title: string | ReactNode;
  centerTitle?: boolean;
  fontSizeTitleHeader?: modalHeaderTitleType;
  skillStatus?: skillStatusType;
  activeJobTitle?: boolean;
  jobTitle?: string;
}

const HeaderTitle: FC<IHeaderTitleProps> = (props) => {
  const { title, centerTitle, fontSizeTitleHeader, skillStatus, activeJobTitle, jobTitle } = props;
  const theme = useTheme();

  return (
    <AtomGrid
      sx={{
        width: styleConfigs.dimensions.percent100,
        display: 'flex',
        flexFlow: 'wrap',
        alignItems: 'center',
        justifyContent: 'space-between',
        columnGap: styleConfigs.marginPadding.custom20rem,
        rowGap: styleConfigs.marginPadding.custom10rem,
        [theme.breakpoints.down('sm')]: {
          rowGap: styleConfigs.marginPadding.custom16rem,
        },
      }}
    >
      <AtomFlex
        sx={{
          width: centerTitle ? styleConfigs.dimensions.percent100 : styleConfigs.dimensions.unset,
          gap: styleConfigs.marginPadding.custom3rem,
          [theme.breakpoints.down('sm')]: {
            gap: styleConfigs.marginPadding.empty,
          },
        }}
      >
        <AtomTypography
          variant={fontSizeTitleHeader}
          sx={{
            alignSelf: centerTitle ? 'center' : undefined,
          }}
        >
          {title}
        </AtomTypography>
        {activeJobTitle && (
          <AtomTypography component="p" variant="h5" fontWeight={500}>
            <Trans
              ns="HeaderTitle"
              i18nKey="JOB_TITLE_TEXT_ADDITIONAL"
              values={{ jobTitle }}
              components={{ b: <b /> }}
            />
          </AtomTypography>
        )}
      </AtomFlex>
      {skillStatus && <SkillTrackerStatusSpan status={skillStatus} />}
    </AtomGrid>
  );
};

export default HeaderTitle;
